import { useEffect, useState } from 'react';

/**
 * True quando há qualquer modal/dialog aberto no DOM — tanto o BottomSheet custom
 * quanto o Sheet (Radix) marcam `aria-modal="true"` e fazem portal direto no <body>.
 *
 * Usado pra esconder a tap bar enquanto um modal está aberto: a barra é near-white
 * (`bg-background`) e o backdrop dos sheets é translúcido (rgba(15,15,20,0.45)), então
 * a barra vazava por baixo como um retângulo claro no rodapé (visível na animação de subida).
 */
export function useModalOpen(): boolean {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const check = () => setOpen(document.querySelector('[aria-modal="true"]') !== null);
    check();
    // Portais (createPortal/Radix) entram como filhos diretos do <body> — basta childList aqui.
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true });
    return () => observer.disconnect();
  }, []);

  return open;
}
